import React from "react";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/site/Navbar";
import { SiteFooter } from "@/components/site/SiteFooter";

export const LandingShell = ({ children }) => (
  <div className="min-h-screen bg-background text-foreground">
    <Navbar />
    <main>{children}</main>
    <SiteFooter />
    <Toaster position="top-center" richColors closeButton />
  </div>
);
